import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Route, Routes } from "react-router-dom";
import Layout from './components/layouts/Layout/Layout';
import OpenLayout from './components/layouts/OpenLayout/OpenLayout';
import Assignment from './components/views/Assignment/Assignment';
import DriverAssignment from './components/views/DriverAssignment/DriverAssignment';
import DriverPaymentReport from './components/views/DriverPaymentReport/DriverPaymentReport';
import DriverReport from './components/views/DriverReport/DriverReport';
import Drives from './components/views/Drivers/Drivers';
import Home from './components/views/Home/Home';
import IncomeReport from './components/views/IncomeReport/IncomeReport';
import Labels from './components/views/Labels/Labels';
import MaintenanceLogReport from './components/views/MaintenanceLogReport/MaintenanceLogReport';
import PaymentOrderReport from './components/views/PaymentOrderReport/PaymentOrderReport';
import PollsReport from './components/views/PollsReport/PollsReport';
import Profiles from './components/views/Profiles/Profiles';
import RoutesReport from './components/views/RoutesReport/RoutesReport';
import RoutesReportByStatus from './components/views/RoutesReportByStatus/RoutesReportByStatus';
import CaptureService from './components/views/CaptureService/CaptureService';
import ServicesReport from './components/views/ServicesReport/ServicesReport';
import ServiceTypeConcepts from './components/views/ServiceTypeConcepts/ServiceTypeConcepts';
import ServiceTypes from './components/views/ServiceTypes/ServiceTypes';
import SignIn from './components/views/SignIn/SignIn';
import UploadSale from './components/views/UploadSale/UploadSale';
import Users from './components/views/Users/Users';
import Vehicles from './components/views/Vehicles/Vehicles';
import WeeklyProduction from './components/views/WeeklyProduction/WeeklyProduction';
import AppContextProvider from './context/appContext';
import { AuthProvider } from "./hooks/useAuth";
import reportWebVitals from './reportWebVitals';
import './styles/styles.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppContextProvider>
      <HashRouter>      
        <AuthProvider>
          <Routes> 
            <Route element={<OpenLayout />}>
              <Route path="/" element={<SignIn />} />
              <Route path="/login" element={<SignIn />} />
              <Route path="/ecofy-manager" element={<SignIn />} />
              <Route path="*" element={<Home to="/" replace />} />   
            </Route>
            <Route element={<Layout />}>
              <Route path="home" element={<Home />} />
              <Route path="servicesReport" element={<ServicesReport />} />
              <Route path="pollsReport" element={<PollsReport />} />
              <Route path="uploadSale" element={<UploadSale />} />
              <Route path="assignment" element={<Assignment />} />
              <Route path="driverAssignment" element={<DriverAssignment />} />
              <Route path="driverReport" element={<DriverReport />} />
              <Route path="driverPaymentReport" element={<DriverPaymentReport />} />              
              <Route path="profiles" element={<Profiles />} />
              <Route path="users" element={<Users />} />
              <Route path="vehicles" element={<Vehicles />} />
              <Route path="drivers" element={<Drives />} />
              <Route path="labels" element={<Labels />} />
              <Route path="weeklyProduction" element={<WeeklyProduction />} />
              <Route path="incomeReport" element={<IncomeReport />} />       
              <Route path="serviceTypes" element={<ServiceTypes />} />                     
              <Route path="serviceTypeConcepts" element={<ServiceTypeConcepts />} />
              <Route path="maintenanceLogReport" element={<MaintenanceLogReport />} />
              <Route path="paymentOrderReport" element={<PaymentOrderReport />} />
              <Route path="routesReport" element={<RoutesReport />} />
              <Route path="routesReportByStatus" element={<RoutesReportByStatus />} />
              <Route path="capture" element={<CaptureService />} />
              <Route path="*" element={<Home to="/" replace />} />   
            </Route>         
          </Routes>   
        </AuthProvider>  
      </HashRouter>
    </AppContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
